import React, { useState, useEffect } from "react";
import Select from "react-select/creatable"
import { AvField } from 'availity-reactstrap-validation'

const createOption = (label) => ({
  label: label,
  value: label,
});

const defaultYearOption = () => {
    let option = []
    var d = new Date();
    var n = d.getFullYear();
    for(let i = n-20; i < n+5; i++) {
    	option.push(createOption(i))
    }

    return option
}

const YearSelect = (props) => {
    const [ selectedtValue, setSelectedValue ] = useState();
    const [ isLoading, setIsLoading ] = useState(false);
    const [ options, setOptions ] = useState(defaultYearOption())
    const { 
        name, 
        errorMessage, 
        defaultValue = new Date().getFullYear(), 
        validate, 
        onChange = null,
        onInputChange = null
    } = props

    useEffect(() => {
        defaultVal()
    }, [defaultValue])

    const handleChange = (values) => {
        setSelectedValue(values)
        if(onChange) {
            onChange(values)
        }
    }

    const handleCreate = (inputValue) => {
        if (inputValue.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')) {
            setIsLoading(true)
            setTimeout(() => {
                const newOption = createOption(inputValue)
                setIsLoading(false)
                setOptions([...options, newOption])
                setSelectedValue(newOption)
            }, 250)
        }
    }

    const defaultVal = () => {
        const filter = options.filter(option => option.value === defaultValue)
        setSelectedValue(filter[0])
    }

    return (
        <>
            <Select 
                isDisabled={isLoading}
                isLoading={isLoading}
                options={options} 
                onCreateOption={handleCreate}
                value={selectedtValue} 
                onChange={handleChange}
            />
            <AvField 
                errorMessage={errorMessage}
                name={name}
                type="hidden" 
                value={selectedtValue?.value} 
                validate={validate}
            />
        </>
    )
}

export default YearSelect;